<template>
    <rkm-modal
        :buttons="['cancel']"
        large
        ref="RkmModal"
        title="Histórico do atendimento"
    >
        <rkm-alert show info>
            <strong>Paciente:</strong>
            {{model.nomePaciente}}

            <template v-if="model.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                <strong>({{model.nomeSocial}})</strong>
            </template>
        </rkm-alert>

        <rkm-table
            :fields="fields.tables.historicoAtendimento"
            :items="items"
            hide-filters
            hide-pagination
            hover
            striped
        >
            <template v-slot:cell(setor)="{ item }">
                {{ item.setor }}
                <rkm-button
                    v-if="item.setor == 'EVASÃO'"
                    class="ml-2"
                    color="secondary"
                    small
                    v-rkm-popover.hover.left="
                        {
                            title: 'Dados da evasão',
                            html: true,
                            content:
                                '<b>Usuário responsável:</b> ' + (item.usuario || '') + '<br/>' +
                                '<b>Motivo da evasão:</b> ' + item.motivoEvasao + '<br/>' +
                                '<br/><b>Último setor:</b> ' + ultimoSetor
                        }
                    "
                >
                    <rkm-icon icon="comment" />
                </rkm-button>
                <rkm-button
                    v-if="item.setor == 'CANCELAMENTO DA EVASÃO'"
                    class="ml-2"
                    color="secondary"
                    small
                    v-rkm-popover.hover.left="
                        {
                            title: 'Dados do cancelamento da evasão',
                            html: true,
                            content:
                                '<b>Motivo do cancelamento da evasão:</b> ' + item.motivoCancelamentoEvasao +
                                '<br/><b>Último setor:</b> ' + ultimoSetor
                        }
                    "
                >
                    <rkm-icon icon="comment" />
                </rkm-button>

                <rkm-button
                    v-if="item.setor == 'ATENDIMENTO FINALIZADO'"
                    class="ml-2"
                    color="secondary"
                    small
                    v-rkm-popover.hover.left="
                        {
                            title: 'Dados do atendimento finalizado',
                            html: true,
                            content:
                                '<b>Último setor:</b> ' + ultimoSetor
                        }
                    "
                >
                    <rkm-icon icon="comment" />
                </rkm-button>

                <rkm-button
                    v-if="item.setor == 'FAA EXCLUÍDA' && ultimoSetor != null"
                    class="ml-2"
                    color="secondary"
                    small
                    v-rkm-popover.hover.left="
                        {
                            title: 'Dados da FAA excluída',
                            html: true,
                            content: '<b>Último setor:</b> ' + ultimoSetor
                        }
                    "
                >
                    <rkm-icon icon="comment" />
                </rkm-button>

                <rkm-button
                    v-if="item.setor == 'FAA CANCELADA'"
                    class="ml-2"
                    color="secondary"
                    small
                    v-rkm-popover.hover.left="
                        {
                            title: 'Dados da FAA cancelada',
                            html: true,
                            content:
                                '<b>Motivo do cancelamento:</b> ' + item.motivoCancelamento +
                                '<br/><b>Último setor:</b> ' + ultimoSetor
                        }
                    "
                >
                    <rkm-icon icon="comment" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-modal>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        fields() {
            return {
                tables: {
                    historicoAtendimento: [
                        { key: 'setor', label: 'Setor/Desfecho'},
                        { key: 'usuario', label: 'Usuário'},
                        { key: 'cbo', label: 'CBO'},
                        { key: 'data', label: 'Data'},
                        { key: 'hora', label: 'Hora'},
                    ],
                },
            }
        },
    },
    created() {
        this.repositories = {
            pacienteBusca: this.getConectaSusRepository('prontoAtendimento.pacienteBusca')
        }
    },
    data: () => ({
        items: [],
        model: {
            nomePaciente: null,
            preferenciaNomeId: null,
            nomeSocial: null,
        },
        ultimoSetor: null,
        enums: { preferenciaNome },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.model.nomePaciente = item.pacienteNome
            this.model.preferenciaNomeId = item.preferenciaNomeId
            this.model.nomeSocial = item.nomeSocial
            this.ultimoSetor = item.setorAtual

            this.setLoading()

            this.repositories.pacienteBusca.show(item.faaId)
                .then(response => {

                    this.items = response.data.atendimentos
                    this.$refs.RkmModal.show()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ error, repository ],
}
</script>